import { BaseModel } from "./Base.Models";

export class PlanModel extends BaseModel {
    public name:string;
    public cost :number;
}
